export default __webpack_public_path__ + "static/media/instagram.98fd6b85.svg";